/**
 * Full JSON-LD schema array for /bass-lessons/what-i-teach: four
 * VideoObject entries (the #34 convention every video-bearing page
 * follows) plus the ItemList indexing them as example lessons.
 *
 * Previously lived inline in app.routes.ts's static route data. Moved here
 * 2026-09-14 so it's set at runtime via SEOService — see
 * WhatITeachContentComponent — inside this route's own lazy chunk instead
 * of the eager route-data bundle.
 */
export function buildWhatITeachPageSchemas(): Record<string, unknown>[] {
  return [
    {
      '@type': 'VideoObject',
      name: 'Putting Names To The Sound',
      description:
        'Music is a language. This is where I start when a student first asks me what to practice.',
      thumbnailUrl: 'https://i.ytimg.com/vi/fXeLnNk3y4U/hqdefault.jpg',
      uploadDate: '2025-07-30T12:00:00+00:00',
      embedUrl: 'https://www.youtube.com/embed/fXeLnNk3y4U',
      contentUrl: 'https://www.youtube.com/watch?v=fXeLnNk3y4U',
      duration: 'PT2M40S',
    },
    {
      '@type': 'VideoObject',
      name: 'Defining A Scale',
      description:
        'Scales come up in every conversation about practice, and in three minutes I lay out the way I look at them.',
      thumbnailUrl: 'https://i.ytimg.com/vi/82464BLwDws/hqdefault.jpg',
      uploadDate: '2024-11-30T12:00:00+00:00',
      embedUrl: 'https://www.youtube.com/embed/82464BLwDws',
      contentUrl: 'https://www.youtube.com/watch?v=82464BLwDws',
      duration: 'PT3M13S',
    },
    {
      '@type': 'VideoObject',
      name: 'What Notes Go Where In The Rhythm And Why',
      description:
        'Constructing a bass line is more than picking the right notes, and when a student wants to know why a line works I walk through the reasons the way I do here.',
      thumbnailUrl: 'https://i.ytimg.com/vi/p_B16KQorow/hqdefault.jpg',
      uploadDate: '2025-07-13T12:00:00+00:00',
      embedUrl: 'https://www.youtube.com/embed/p_B16KQorow',
      contentUrl: 'https://www.youtube.com/watch?v=p_B16KQorow',
      duration: 'PT6M43S',
    },
    {
      '@type': 'VideoObject',
      name: 'Practice Playing Music',
      description:
        'The fastest way to get better on bass is to practice music, not just exercises. I say this to every student in their first lesson, and I keep coming back to it as they go.',
      thumbnailUrl: 'https://i.ytimg.com/vi/2HmBfhvNw8I/hqdefault.jpg',
      uploadDate: '2025-02-04T12:00:00+00:00',
      embedUrl: 'https://www.youtube.com/embed/2HmBfhvNw8I',
      contentUrl: 'https://www.youtube.com/watch?v=2HmBfhvNw8I',
      duration: 'PT4M22S',
    },
    {
      '@type': 'ItemList',
      name: 'Example Bass Lessons by Russ Rodgers',
      itemListOrder: 'https://schema.org/ItemListOrderAscending',
      numberOfItems: 4,
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          url: 'https://www.youtube.com/watch?v=fXeLnNk3y4U',
        },
        {
          '@type': 'ListItem',
          position: 2,
          url: 'https://www.youtube.com/watch?v=82464BLwDws',
        },
        {
          '@type': 'ListItem',
          position: 3,
          url: 'https://www.youtube.com/watch?v=p_B16KQorow',
        },
        {
          '@type': 'ListItem',
          position: 4,
          url: 'https://www.youtube.com/watch?v=2HmBfhvNw8I',
        },
      ],
    },
  ];
}
